import { useMutation, useQueryClient } from "@tanstack/react-query";

import useApiHelper from "../../hooks/useApiHelper";
import { IFeature } from "../../models/Feature/Feature";
import { FeatureQueryKeys } from "./keys";

interface IUpsertFeatureRequest {
  name: string;
  status: number;
}

export default function useFeatureMutations() {
  const { post, put, del } = useApiHelper();
  const queryClient = useQueryClient();

  const create = useMutation({
    mutationFn: (req: IUpsertFeatureRequest) => post("/feature", req),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: FeatureQueryKeys.all() });
    },
  });

  const update = useMutation({
    mutationFn: (feature: IFeature) =>
      put(`/feature/${feature.id}`, {
        name: feature.name,
        status: feature.status,
      } as IUpsertFeatureRequest),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: FeatureQueryKeys.all() });
    },
  });

  const remove = useMutation({
    mutationFn: (featureId: string) => del(`/feature/${featureId}`),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: FeatureQueryKeys.all() });
    },
  });

  return {
    create,
    update,
    remove,
  };
}
